/**
 * Created by daniel on 16/04/17.
 *
 * This component acts as a host for other rows.
 *
 * Can only be placed in CellItems (apart from root item)
 *
 */

import React, {Component} from 'react';
import StyleItem from "./StyleItem";
import DropZone from "../ui/DropZone";
import * as _ from "lodash/object";

class TableItem extends Component {
  render() {
    return (
      <table
        id={this.props.contentId}
        className={[this.props.contentId, this.props.viewClass,].join(" ").trim()}
        ref={(node) => {
          _.toPairs(this.props.viewAttributes).map((item) => {
            return node && node.setAttribute(item[0], item[1]);
          });
        }}
        {...this.props.eventHandlers}
        style={{
          width: this.props.styleWidth,
          height: this.props.styleHeight,
          padding: this.props.stylePadding,
          backgroundColor: this.props.styleBackgroundColour,
          color: this.props.styleTextColour,
          textAlign: this.props.styleTextAlignment,
        }}
      >
        <StyleItem selectorPrefix={this.props.contentId + " "} styleObject={this.props.viewCss}/>
        <tbody>
        {
          this.props.children.length > 0 ? this.props.children : <tr><td><DropZone text={this.props.configName}/></td></tr>
        }
        </tbody>
      </table>
    );
  }
}

export default TableItem;


// WEBPACK FOOTER //
// ./src/App/Editor/components/primitives/TableItem.js